import React, { ChangeEvent, useState } from 'react'
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form'
import { ReactComponent as Icon } from '../../../assets/icons/paper-clip.svg'
import s from './index.module.scss'

interface IBasicProps {
	name: string
	errors?: any
	setValue: UseFormSetValue<any>
	getValues?: UseFormGetValues<any>
}

type IProps = React.HTMLProps<HTMLInputElement> & IBasicProps

function FileInput({ name, errors, label, setValue, getValues, ...props }: IProps) {
	const [fileName, setFileName] = useState<string>('')

	const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
		const file = ev.target.files?.[0]

		if (file) {
			setFileName(file.name)
			setValue(name, file)
		}
	}

	return (
		<label className={s.wrapper}>
			{label && <span className={s.label}>{label}</span>}

			<input {...props} type="file" name={name} className={s.input} onChange={onChange} />

			<span className={s.fileWrapper}>
				<span>{fileName ? fileName : getValues && getValues(name) ? getValues(name) : 'Завантажити файл'}</span>
				<Icon />
			</span>

			{errors && name && errors[name] && <span className={s.error}>{errors[name]?.message}</span>}
		</label>
	)
}

export default FileInput
